var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",function(){return [_vm._v(" Download "+_vm._s(_vm.name)+" ")]})],2),(_vm.is_show_progress)?_c('div',{staticClass:"loading_custom"},[_c('ProgressBar',{staticStyle:{"width":"300px"},attrs:{"value":_vm.progress}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }